import React from 'react';
import Icon404 from '../../assets/illustration/error/404.svg';
import HomeButton from '../../components/button/HomeButton'


const NotFound = () => (
    <div className="flex flex-col items-center justify-center my-48 text-center">
        <img src={Icon404} alt="404 Error" className="w-3/4 h-auto mb-12" />
        <p className="text-3xl  text-burnt-coffee font-heading uppercase font-semibold mb-12">Ops! La pagina che stai cercando non esiste.</p>
        <div className=''>
            <HomeButton />
        </div>
    </div>
);

export default NotFound;
